define('config/params',[
    'underscore',
    'json!config/sharedConfig.json',
    'common/payment/piqConstants',
    'config/routeIds',
    'config/routeTranslations',
], function (_, sharedConfig, piqConstants, routeIds, routeTranslations) {

    return _.extend({}, sharedConfig, {
        appType: 'mobile',
        defaultDepositAmount: 30,
        emailVerificationViewUrl: 'features/emailVerification/emailVerification.html',
        emptyString: '',
        true: true,
        false: false,
        login: {
            maxAttempts: 26
        },
        olarkId: '7158-364-10-2252',
        piq: piqConstants,
        piqChannel: piqConstants.channel.MOBILE,
        routeIds: routeIds,
        routeTranslations : routeTranslations,
        shellViewModelServiceId: 'shellViewModel',
        transitionMappings: {
            'pop-in': 150,
            'pop-out': 150,
            'fade-in': 150,
            'fade-out': 150
        },
        commandLoadingTimeout: 0,
        images: {
            freeSpinSpriteImage: '/components/casumo-common/src/images/sprites/items/free-spin-sprite.png',
            depositBonusImage: '/components/casumo-common/src/images/sprites/items/deposit-bonus.png',
            moneyImage: '/components/casumo-common/src/images/sprites/items/money.png',
            funinatorImage: '/components/casumo-common/src/images/sprites/items/funinator.png'
        },
        imageDomainMappings: {
            'cms.casumo.com/wp-content/uploads': 'images.casumo.com'
        },
        preloadContent: {
            root: {
                loggedOut: ['mobile-game.*',  'mobile.*'],
                loggedIn: ['payment-method.*']
            },

            market: {
                loggedOut: [],
                loggedIn: []
            }
        }
    });
});

